const { map } = require('jquery');

define(function (require) {
	//logic
	const autocomplete_logic = require('./autocomplete_logic');
	const geolocation_logic = require('./geolocation_logic');
	const map_logic = require('./map_logic');
	const site_selection_logic = require('./site_selection_logic');
	const data_handling_logic = require('./data_handling_logic');

	//This is the general logic for site the advanced site selection. General utilities go here, otherwise the specific 
	//logic is imported into different files using the extend below.
	return _.extend({
		
		checkSiteConstraints: function (primary, config) {
			let siteHiddenByConstraints = false;
			let siteType = primary ? 'primarySite' : 'additionalSites'
			//if we're hiding or set to display only, don't do anything.
			if (config.constraints &&
				config.constraints[siteType] &&
				(config.constraints[siteType].hidden ||
					config.constraints[siteType].readOnly)) {
				siteHiddenByConstraints = true;
			}
			return siteHiddenByConstraints;
		},
		convertCPQSite: function (site) {
			if (site.type) {
				var type = site.type.toLowerCase();
				if (type == 'address') {
					site.id = site.address;
				} else if (type == 'parcel') {
					site.id = site.parcel
				} else if (type == 'coords') {
					//nothing to do here, already in correct format.
				}
			}
			return site;
		},
		getCountryCode: function (cultureInfo) {
			var ret = 'US'
			var split = cultureInfo.split('-');
			if (split.length == 2) {
				ret = split[1];
			}
			return ret;
		},
		isCurrentSiteFieldRequired(isPrimary, validation){
			let siteType = isPrimary ? 'primarySite' : 'additionalSites'
			let required =  validation && validation[siteType] && validation[siteType].required;
			//if we're looking at a primary site, required is already set appropriately. If we're looking at an additional site, we need to check if any additional sites are selected already, as that will have met the requirement
			required = isPrimary ? required : this.additionalSiteSelected() ? false : required;
			return required;
		}
	},autocomplete_logic, geolocation_logic, map_logic, site_selection_logic, data_handling_logic);
});
